import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./payments.css";

const PaymentFailure = () => {
  const { txnId } = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/stripepayment");
  };

  return (
    <div className="payment-card">
      <div className="payment-content-center">
        <div className="payment-status-icon failed">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="#F8D7DA"/>
            <path d="M16 32L32 16M32 32L16 16" stroke="#DC3545" strokeWidth="3" strokeLinecap="round"/>
          </svg>
        </div>
        <h2 className="payment-status-failed">Payment Failed</h2>
        <p>Your payment could not be processed.</p>
        <div className="txn-simple">TRANSACTION ID: <span>{txnId}</span></div>
        <button className="back-btn-better" onClick={handleBack}>Back to Home</button>
      </div>
    </div>
  );
};

export default PaymentFailure;